import {gql, useMutation} from "@apollo/client";

const REMOVE_TEAM_MUTATION = gql`
mutation RemoveTeam ($seasonId: Int, $teamId: Int!) {
  removeTeam(seasonId: $seasonId, teamId: $teamId) {
    success
  }
}
`;

export default function RemoveTeamMutation() {
    return useMutation(REMOVE_TEAM_MUTATION);
}